import { useCallback } from "react";
import { useSearchParams } from "react-router";

export function usePageParam(paramKey = "page") {
  const [searchParams, setSearchParams] = useSearchParams();
  const valorDaUrl = parseInt(searchParams.get(paramKey) ?? "1", 10);
  const currentPage =
    Number.isFinite(valorDaUrl) && valorDaUrl >= 1 ? valorDaUrl : 1;

  const setCurrentPage = useCallback(
    (pagina: number) => {
      const next = new URLSearchParams(searchParams);
      next.set(paramKey, pagina.toString());
      setSearchParams(next);
    },
    [paramKey, searchParams, setSearchParams],
  );

  return [currentPage, setCurrentPage] as const;
}
